import { getEmptyTemplateConfiguration } from '@/utils/emptyTemplate';
import type { ITemplate } from '@/typescript/interfaces/ITemplate';
import type { ITemplateDTO } from '@/typescript/interfaces/ITemplateDTO';

function templateToDTO(template: ITemplate): ITemplateDTO {
    return {
        id: template.id,
        thumbnail: template.thumbnailUrl,
        name: template.name,
        projectJson: JSON.stringify({ ...template.configuration }),
    };
}

function DTOToTemplate(
    dto: ITemplateDTO = {
        id: 1,
        name: 'name',
        projectJson: `{
            "fields": [
                {
                    "id": "a63431cb-4bbb-4fc9-98b3-841649954428",
                    "editable": true,
                    "transform": {
                        "position": {
                            "x": 800,
                            "y": 200
                        },
                        "angle": 0,
                        "scale": {
                            "x": 1,
                            "y": 1
                        },
                        "size": {
                            "width": 776.6356482856195,
                            "height": 262.15999999999997
                        }
                    },
                    "textAlign": "left",
                    "characterSpacing": 1,
                    "lineSpacing": 0,
                    "font": "Albret",
                    "fontSize": 25,
                    "defaultText": "Votre texte",
                    "color": "#000000",
                    "isBold": false,
                    "isUnderlined": false,
                    "isItalic": false,
                    "frameSize": {
                        "width": 894,
                        "height": 808
                    },
                    "text": "Votre texte",
                    "styles": {
                        "0": {
                            "0": {
                                 "fill": "#A52A2A"
                            },
                            "1": {
                                "fontSize": 100
                            },
                            "2": {
                                "fontSize": 200, "italic": "true"
                            },
                            "3": {
                                "fontSize": 232, "underline": "true"
                            },
                            "4": {
                                "fontSize": 100, "fill": "#A52A2A"
                            },
                            "6": {
                                "fontSize": 600, "fontFamily": "BebasNeue-Regular"
                            }
                        }
                    }
                }
            ]
        }`,
        thumbnail: 'https://www.example.com/thumbnail.jpg',
    },
): ITemplate {
    const configuration = JSON.parse(dto.projectJson);
    return {
        id: dto.id,
        thumbnailUrl: dto.thumbnail,
        name: dto.name,
        configuration: Array.isArray(configuration) ? getEmptyTemplateConfiguration() : configuration,
    };
}

export { DTOToTemplate, templateToDTO };
